export const SAVED_VIEW_SCOPES = {
  PRIVATE: 'private',
  PARTNER: 'partner',
}

// Keys stored in the partner-wide config (state.preferences.partnerConfig).
export const PARTNER_CONFIG_KEYS = {
  SHOW_PARTNER_LOGO_IN_HEADER: 'showPartnerLogoInHeader',
}
